import { LocationQueryValue } from 'vue-router';

type QueryValue = LocationQueryValue | LocationQueryValue[] | undefined;

/**
 * Reads a `redirect` query value. Only same-origin paths are accepted, so a crafted
 * link cannot bounce the user to another site right after signing in.
 */
export const redirectTarget = (value: QueryValue): string | null => {
  const path = Array.isArray(value) ? value[0] : value;
  if (typeof path !== 'string' || !path.startsWith('/')) {
    return null;
  }
  // `//host` and `/\host` are read as protocol-relative URLs by browsers.
  return path.startsWith('//') || path.startsWith('/\\') ? null : path;
};
